export default "__VITE_ASSET__lfRIws6f__"